module.exports = __webpack_public_path__ + "img/K@2x.08281450.jpg";